<template>
  <div class="user-app-wrapper">

    <!--操作按钮-->
    <div class="custom-wrapper op-wrapper">
      <el-button
        type="danger"
        size="medium"
        @click="addUserAppDialogVisible = true">添加用户应用</el-button>
    </div>

    <!--过滤表单-->
    <user-app-filter @filter="updateTableData" />

    <!--用户应用列表-->
    <div class="user-app-list custom-wrapper" v-if="userAppList.length > 0">
      <div class="user-app"
        v-for="userApp in userAppList"
        :key="userApp.uesr_app_id">
        <el-card>
          <div slot="header" class="clearfix">
            <el-tooltip placement="top">
              <div slot="content">
                用户 ID: {{ userApp.userid }} <br/>
                用户昵称 : {{ userApp.user_detail.nickname }} <br/>
                代理商 ID: {{ userApp.agentid }} <br/>
                代理商   : {{ userApp.agent_detail.agentname }} <br/>
                代理商昵称: {{ userApp.agent_detail.nickname }}
              </div>
              <span>{{ userApp.user_detail.username }}</span>
            </el-tooltip>
          </div>

          <div class="user-app-info">
            <div class="label-info">
              <p>应用名:</p>
              <p>{{ userApp.app_store_detail.app_module_name }}</p>
            </div>
            <div class="label-info">
              <p>应用分类:</p>
              <p>{{ userApp.app_store_detail.app_category_name_i18n[0].name }}</p>
            </div>
            <div class="label-info">
              <p>开始时间:</p>
              <p>{{ userApp.start_at | dateformat }}</p>
            </div>
            <div class="label-info">
              <p>过期时间:</p>
              <p>{{ userApp.expire_at | dateformat }}</p>
            </div>
          </div>

          <div class="user-app-op">
            <el-button
              type="text"
              @click="onEditClick(userApp)">修改</el-button>
            <el-button
              type="text"
              class="danger-text"
              @click="onDeleteClick(userApp)">删除</el-button>
          </div>
        </el-card>
      </div>

    </div>

    <div
      class="custom-wrapper"
      style="display: flex;
        justify-content: center;
        padding: 20px 0;
        color: #909399;"
      v-else>
      暂无数据
    </div>

    <!--列表分页-->
    <custom-paginate
      :count="userAppCount"
      @page-change="updateTableData" />

    <dialog-add-user-app
      @data-change="updateTableData"
      :visible.sync="addUserAppDialogVisible" />

    <dialog-edit-user-app
      @data-change="updateTableData"
      :editing-user-app="editingUserApp"
      :visible.sync="editUserAppDialogVisible" />

  </div>
</template>

<script>
import CustomPaginate from '@/components/CustomPaginate'
import UserAppFilter from './components/UserAppFilter'
import DialogAddUserApp from './components/DialogAddUserApp'
import DialogEditUserApp from './components/DialogEditUserApp'

import { mapState, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_PAGE_SIZE, SET_LOADING } from '@/store/modules/table'

export default {
  name: 'UserApp',
  components: {
    CustomPaginate,
    UserAppFilter,
    DialogAddUserApp,
    DialogEditUserApp
  },
  data () {
    return {
      addUserAppDialogVisible: false,

      editUserAppDialogVisible: false,
      editingUserApp: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'filters'
    ]),
    ...mapState('store', [
      'userAppList',
      'userAppCount'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_PAGE_SIZE,
      SET_LOADING
    ]),
    ...mapActions('store', [
      'getUserApps',
      'deleteUserApp'
    ]),

    onEditClick (userApp) {
      this.editingUserApp = userApp
      this.editUserAppDialogVisible = true
    },
    async onDeleteClick (userApp) {
      try {
        await this.$confirm(
          '此操作将永久删除用户应用，是否继续？', '删除用户应用',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteUserApp({
          user_app_id: userApp.user_app_id
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    async updateTableData () {
      this.setLoading(true)

      try {
        await this.getUserApps({
          page: this.page,
          pageSize: this.pageSize,
          condition: this.filters
        })
      } catch (err) {
        console.log(err)

        this.$message({
          type: 'error',
          message: '获取用户应用列表失败'
        })
      }
      this.setLoading(false)
    }
  },
  mounted () {
    this.setPage(1)
    this.setPageSize(8)
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/base';

.user-app-wrapper {

  .op-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .user-app-list {
    display: flex;
    justify-content: space-start;
    align-items: center;
    flex-flow: row wrap;

    .user-app {
      width: 23%;
      padding: 10px;

      .user-app-info {

        .label-info {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        p {
          line-height: 1.5;
          margin: 0;
        }
      }

      .user-app-op {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/UserApp.vue